import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2ABCIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 21.486 15.276",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 21.486),
    children: [/*#__PURE__*/jsx("path", {
      d: "m3.053 14.514-1.833-9.43a2.4 2.4 0 1 1 4.712-.916l1.832 9.429"
    }), /*#__PURE__*/jsx("path", {
      d: "m2.136 9.8 4.712-.916"
    }), /*#__PURE__*/jsx("path", {
      d: "m8.917 12.657v-12.007"
    }), /*#__PURE__*/jsx("path", {
      d: "m8.917.65h2.4a2.4 2.4 0 0 1 2.4 2.4v1.2a2.4 2.4 0 0 1 -2.4 2.4h-2.4"
    }), /*#__PURE__*/jsx("path", {
      d: "m8.917 6.653h2.4a2.4 2.4 0 0 1 2.4 2.4v1.2a2.4 2.4 0 0 1 -2.4 2.4h-2.4"
    }), /*#__PURE__*/jsx("path", {
      d: "m20.76 2.075a4.8 4.8 0 0 0 -5.35 4.18l-.292 2.381a4.8 4.8 0 0 0 4.179 5.35"
    })]
  });
};

export { PM2ABCIcon };
//# sourceMappingURL=abc.js.map
